import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as pullRequests from '../../pull-requests'

export const RESOURCE = {
  payload: {
    description: 'One pull request, keyed by its number.',
    dimension: pullRequests.RESOURCE.payload,
    level: 0,
    name: 'Pull Request',
    partialId: PartialId.Standard.create('pull_request'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
